<div class="rounded-md border border-slate-700 bg-slate-800/40 p-2">
  <div class="mb-1 text-xs font-semibold text-slate-200">{{ view().title || 'Risk metrics' }}</div>
  @if (view().rows.length === 0) {
    <div class="text-xs text-slate-400">No metrics provided.</div>
  } @else {
    <dl class="grid grid-cols-2 gap-2 text-xs">
      @for (m of view().rows; track $index) {
        <div class="flex items-baseline justify-between gap-2">
          <dt class="text-slate-400">{{ m.label }}</dt>
          <dd class="font-mono text-slate-100">{{ m.value }}{{ m.unit ? ' ' + m.unit : '' }}</dd>
        </div>
      }
    </dl>
  }
</div>
